import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { Provider } from 'react-redux'; // Импортируем Provider из react-redux
import store from './redux/store'; // Импортируем ваш store



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}> {/* Оборачиваем приложение в Provider */}
    <App />
  </Provider>
);

